import react, {useState, useEffect} from "react";
import { Image as AntdImage, Modal, Button, Input, Space, Typography, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";

import Api from "../../../api";
import {getSearchParams, ModalConfirm} from "../../../utils/tool";
import TeamModal from "./teamModal";
import {pagingParam} from "../../../utils/defaultValue";
import SelfTable from "../../../components/SelfTable"
import PersonalSelectModal from "../../../components/PersonalSelectModal"
import "./index.scss"

const { Text, Link } = Typography;
const { TextArea } = Input;
const TeamDetails = ({}) => {
    const history = useHistory();
    const [reportDetails, setReportDetails] = useState({});
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [teamForm, setTeamForm] = useState({});
    const [teamOpen, setTeamOpen] = useState(false);
    const [teamTitle, setTeamTitle] =  useState("");
    const [operationData, setOperationData] = useState({});
    const [teamUserOpen, setTeamUserOpen] = useState(false);

    // 分页
    const [pagination, setPagination] = useState({
        "pageNum": 0,
        "pageSize": 0,
        "total":0
    });

    // 列表数据
    const [listData, setListData] = useState([]);

    const [userIds, setUserIds] = useState([]);

    // 当前正在操作的数据KEY
    const [editingKey, setEditingKey] = useState('');

    const [tableLoading, setTableLoading] = useState(false);

    // 列表选择数据
    const [selectedRowKey, setSelectedRowKey] = useState([]);

    // 查询数据
    const [searchData, setSearchData] = useState({
        ...pagingParam,
    });
    const [teamUserLoading, setTteamUserLoading] = useState(false);

    useEffect(() => { 
        getTeamDetailsF();
    }, []);

    useEffect(() => { 
        getTeamUserF();
    }, [searchData]);

    const columns = [
        {
            title: "姓名",
            dataIndex: 'nickName',
            width:'100px',
          },
          {
            title: "工号",
            dataIndex: 'userName',
          },
          {
            title: "子公司/部门",
            dataIndex: 'deptName',
          },
          {
            title: "电话",
            dataIndex: 'phonenumber',
          },
           {
            title: "email",
            dataIndex: '邮箱',
          },
        {
            title: '操作',
            width: '130px',
            render: (_, record) => {
                return <Space>
                <Link  onClick={() => deleteTeamUserF(record)}>
                    删除
                </Link>
            </Space>
            },
        },
    ];


    const getTeamUserF = async() => {
        setTteamUserLoading(true);
        try{
            const res = await Api.Team.getTeamUser({
                data:{
                    reportTeamId: getSearchParams().id,
                    ...searchData
                }
            });
            setTteamUserLoading(false);
            if(res.code === 200){
                setListData(res.rows);
                let _userId = [];
                res.rows.map(item => { 
                    _userId.push(item.userId)
                })
                setUserIds(_userId);
                setPagination({
                    "pageNum": searchData.pageIndex,
                    "pageSize": searchData.pageSize,
                    "total":res.total
                });
            }
        }catch(e){
            setTteamUserLoading(false);
            console.log(e);
        }
    }

    function deleteTeamUserF(item){
        ModalConfirm({
          title: '是否确认移除团队成员"'+item.nickName+'"吗？',
          onOk: async (resolve, reject) => {
            try {
                const res = await Api.Team.deleteTeamUser({data:{
                    reportTeamId:getSearchParams().id,
                    userIds:[item.userId]
                }});
              if (res && res.code === 0) {
                message.success("移除成功");
                getTeamUserF();
                getTeamDetailsF();
              }
              resolve();
            } catch {}
          },
        });
    }

    const handleDelete = async() => {
        if(selectedRowKey.length <= 0){
            message.warning("至少选择1位成员!");
            return false;
        }
        let nameList = [];
        listData.map(item=>{
            if(selectedRowKey.includes(item.userId)){
                nameList.push(item.nickName);
            }
        })
        ModalConfirm({
          title: '是否确认移除团队成员"'+nameList.join(",")+'"吗？',
          onOk: async (resolve, reject) => {
            try {
                const res = await Api.Team.deleteTeamUser({data:{
                    reportTeamId:getSearchParams().id,
                    userIds:selectedRowKey
                }});
                if (res && res.code === 0) {
                    message.success("移除成功");
                    getTeamUserF();
                    setSelectedRowKey([]);
                    getTeamDetailsF();
                }
                resolve();
            } catch {}
          },
        });
    }

    const getTeamDetailsF = async() => {
        try{
            const res = await Api.Team.getTeamDetails(getSearchParams().id);
            if(res.code === 0){
                setReportDetails(res.data);
            }
        }catch(e){
            console.log(e);
        }
    }

    const updateTeamF = () => {
        setTeamOpen(true);
        setTeamTitle("修改团队")
    }

    const teamCancel = () => {
        setTeamOpen(false);
        getTeamDetailsF();
    }

    const dissolutionTeam = async()=>{
        ModalConfirm({
          title: "是否确认解散团队？",
          onOk: async (resolve, reject) => {
            try {
              const res = await Api.Team.delTeam({data:{id:getSearchParams().id}});
              if (res && res.code === 0) {
                message.success("解散成功");
                // window.close();
                history.push("/page/manage/team");
              }
              resolve();
            } catch {}
          },
        });
    }

    const searchChange = (value, type) => {
        let newOperationData = {...operationData};
        newOperationData[type] = value;
        setOperationData(newOperationData)
    }

    const onSearch = () => {
        let newSearchData = {
            ...searchData,
            ...operationData,
            pageNum:1
        }
        setSearchData(newSearchData);
    }

    const handleAdd = () => {
        setTeamUserOpen(true);
    }


    const onChanges = (pagination, filters) => {
        let newSearchData = {...searchData}
        newSearchData.pageNum = pagination.current;
        newSearchData.pageSize = pagination.pageSize;
        setSearchData(newSearchData);
    };

    const personalSelectCancel = async(param, type) => {
        console.log(param);

        if(type === 'cancel'){
            setTeamUserOpen(false);
            return false;
        }
        
        let userIds = [...param.personal, ...param.team]

        if(userIds.length <= 0){
            message.error("至少添加1位成员!");
            return false;
        }


        const res = await Api.Team.addTeamUser({
            data:{
                reportTeamId: getSearchParams().id,
                userIds:userIds
            }
        })
        if (res && res.code === 0) {
            message.success("添加成功");
            setTeamUserOpen(false);
            getTeamUserF();
            getTeamDetailsF();
        }
    }

    return (
        <div className="teamDetails">
             <div className="teamTitle">
                <Space>
                    <Text className="title" tag="b" size="large">{reportDetails.teamName}</Text> 
                    <EditOutlined onClick={updateTeamF}/>
                    <Text className="dissolutionTeam" type="danger" onClick={dissolutionTeam}>解散团队</Text>
                </Space>
            </div>
            <div className="teamDetailes">
                <Text className="time" type="secondary">建立时间：<span>{reportDetails.createTime}</span></Text>  
                <Text className="pepole" type="secondary">总人数：<span>{reportDetails.teamNum}人</span></Text> 
            </div>
            <div className="teamDetailes">
                <Text className="describe" type="secondary">团队简介：<span>{reportDetails.teamDesc}</span></Text>  
            </div>
           
            <div className="operation">
                <div className="operationLeft">
                    <div className="operationItem">
                        <span className="inputTitle">团队人员：</span>
                        <Input 
                            placeholder="请输入团队人员名称" 
                            value={operationData.name} 
                            onChange={(e)=>{
                                searchChange(e.target.value,"name")
                            }}
                            allowClear={true}
                            onPressEnter={onSearch}
                        />
                    </div>
                </div>

                <Space size={"large"}>
                    <Button type="primary" onClick={handleAdd}>添加人员</Button>
                    <Button type="primary" danger onClick={handleDelete}>删除人员</Button>
                </Space>
            </div>

            <SelfTable
                rowKey={'userId'}
                rowRadioSelection={{
                    type:'checkbox',
                    selectedRowKey:selectedRowKey,
                    setSelectedRowKey:setSelectedRowKey,
                }}
                pagination={{
                    "pageIndex": pagination.pageNum,
                    "pageSize": pagination.pageSize,
                    "total":pagination.total
                }}
                dataSource={listData}
                columns={columns}
                loading={tableLoading}
                onChange={onChanges} 
            />

           <TeamModal
                teamTitle={teamTitle}
                open={teamOpen}
                teamCancel={teamCancel}
                details={reportDetails}
            />

            <PersonalSelectModal
                open={teamUserOpen}
                cancel={personalSelectCancel}
                disabledUserIds={userIds}
                // personalIds = {userIds}
            />
        </div>
    )
}

export default TeamDetails;